import styled from 'styled-components/macro';

export const StyledApplicationList = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 30px;
  margin-top: 30px;
  @media (max-width: 769px) {
    grid-template-columns: 1fr;
  }
`;
